module.exports = __webpack_public_path__ + "static/media/corded_telephone.2ed41fb1.svg";